import { gql } from '@apollo/client'

const BrandListFragment = gql`
  fragment BrandListFragment on Brand {
    id
    autoeatId
    name
    website
    status
    isPublished
    isDeleted
    isFake
    locationCount
    updatedAt
    createdAt
  }
`

export default BrandListFragment
